import { render, staticRenderFns } from "./EditReportNav.vue?vue&type=template&id=5d2f5ff8"
import script from "./EditReportNav.vue?vue&type=script&lang=js"
export * from "./EditReportNav.vue?vue&type=script&lang=js"
import style0 from "./EditReportNav.vue?vue&type=style&index=0&id=5d2f5ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports